// TODO: Make currency-aware. Currently hardcoded to Stripe's USD minimum (50¢).
// https://docs.stripe.com/currencies#minimum-and-maximum-charge-amounts
export const MIN_AMOUNT_IN_MINOR_UNITS = 50

/**
 * Type guard for a chargeable amount: a non-null integer at or above Stripe's
 * minimum. Never coerces — fractional values are rejected, not rounded.
 */
export function isChargeable(amount: number | null): amount is number {
  return amount != null && Number.isInteger(amount) && amount >= MIN_AMOUNT_IN_MINOR_UNITS
}
